import { render, staticRenderFns } from "./yangDetail.vue?vue&type=template&id=5add0040&scoped=true&"
import script from "./yangDetail.vue?vue&type=script&lang=js&"
export * from "./yangDetail.vue?vue&type=script&lang=js&"
import style0 from "./yangDetail.vue?vue&type=style&index=0&id=5add0040&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add0040",
  null
  
)

export default component.exports